export class ll {
  getOptions() {
    return {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
  }
}


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/core/i18n/date/MonthNameShortDayMonthYear.js
 **/